import axios from 'axios'

export default {
    getDrinks(simpleMenu) {
        return axios.get('/drink/v1?simpleMenu=' + simpleMenu)
            .then(response => {
                return response.data
            })
    },
    getFDrinks(simpleMenu, drinkType, brewMethod, roast, coffee, strength) {
        return axios.get('/drink/v1?simpleMenu=' + simpleMenu + '&drinkType=' + drinkType + '&brewMethod=' + brewMethod + '&roast=' + roast + '&coffee=' + coffee + '&strength=' + strength)
            .then(response => {
                return response.data
            })
    }
}